import React from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import { visionURL } from "../../config/environment";

class CalendarEventFileDialog extends React.Component {
  openCalendar(
    title,
    courseTitle,
    courseDescription,
    linkToTheFirstActivity,
    courseId,
    duration,
    dtStart,
    dtEnd,
    allDay
  ) {
    window.open(
      visionURL +
        "/learning_center/api/my_courses/" +
        courseId +
        "/calendar_events?title=" +
        title +
        "&courseTitle=" +
        courseTitle +
        "&courseDescription=" +
        courseDescription +
        "&linkToTheFirstActivity=" +
        linkToTheFirstActivity +
        "&duration=" +
        duration +
        "&dtStart=" +
        dtStart +
        "&dtEnd=" +
        dtEnd +
        "&allDay=" +
        allDay,
      "_blank"
    );
  }

  render() {
    const calendarParams = this.props;

    return (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <Typography>
              Please download the iCalendar file with the event for{" "}
              {calendarParams.courseTitle} and import it into your calendar
              application.
            </Typography>
          </FormControl>
        </Grid>
        <Grid item md={2} xs={6}>
          <FormControl>
            <Button
              value="Close"
              letiant="outlined"
              variant="outlined"
              onClick={() => this.props.onClose()}
              aria-label="Close"
            >
              Close
            </Button>
          </FormControl>
        </Grid>
        <Grid item md={2} xs={6}>
          <FormControl>
            <Button
              type="submit"
              value="submit"
              letiant="outlined"
              variant="outlined"
              onClick={() =>
                this.openCalendar(
                  calendarParams.calendarTitle,
                  calendarParams.courseTitle,
                  calendarParams.courseDescription,
                  calendarParams.linkToTheFirstActivity,
                  calendarParams.courseId,
                  calendarParams.duration,
                  calendarParams.dtStart,
                  calendarParams.dtEnd,
                  calendarParams.allDay
                )
              }
            >
              OK
            </Button>
          </FormControl>
        </Grid>
      </Grid>
    );
  }
}

export default CalendarEventFileDialog;
